export default __webpack_public_path__ + "static/bouquet-62708318a19a9b312d9e576b22f4a442.svg";